// eslint-disable-next-line
import React from 'react'
import { connect } from 'react-redux'

import { notifyError, dismissAllMessages } from '../UserMessaging'
import { translateResourceString } from '../../../util/translationUtility';

import { completeCheckoutAsync } from './placeOrderActionCreators'
import { mapStateToPlaceOrderDetails } from './mapStateToPlaceOrderDetails'
import CheckoutComplete from './CheckoutComplete'

import { validate } from '../Validation/OrderDetailsValidation'
import { orderCanBeSubmittedValidators } from '../Validation/OrderValidators';

const mapCheckoutCompleteStateToProps = (state, ownProps) => {
    var placeOrderDetails = mapStateToPlaceOrderDetails(state);
    placeOrderDetails.constants = state.constants; // Hack on the constants object so we can see what constant values are when we validate
    return {
        buttonText: translateResourceString("/Checkout/Continue/PlaceOrder"),
        backButtonText: translateResourceString("/Checkout/Continue/Back"),
        continueButtonText: translateResourceString("/Checkout/Continue/ContinueToPayment"),
        placeOrderDetails: placeOrderDetails,
        isPlaceOrderPending: state.ui.isPlaceOrderPending,
        onPaymentScreen: state.ui.onPaymentScreen,
        usingPo: state.entities.SelectedPaymentOptionId === state.constants.purchaseOrderPaymentId,
        ...ownProps
    }
}

const orderDetailsCanBeSubmitted = (orderDetails) => validate(orderDetails, orderCanBeSubmittedValidators);

const mapCheckoutCompleteDispatchToProps = (dispatch) => {
    return {
        onCompleteCheckout: (placeOrderDetails) => {
            dispatch(dismissAllMessages());
            const errors = orderDetailsCanBeSubmitted(placeOrderDetails);
            if (errors.length === 0) {
                delete placeOrderDetails.constants; // Remove the property we stuck on to share state above in mapCheckoutCompleteStateToProps
                dispatch(completeCheckoutAsync(placeOrderDetails));
            } else {
                const intro = translateResourceString("/Checkout/PlaceOrder/Errors/Intro") + ": ";
                const message = errors.reduce((acc, cur) => acc + '\n' + cur, intro);
                dispatch(notifyError(message));
            }
        }
    }
}

const CheckoutCompleteContainer = connect(mapCheckoutCompleteStateToProps, mapCheckoutCompleteDispatchToProps)(CheckoutComplete)

export default CheckoutCompleteContainer
